import { render, staticRenderFns } from "./Proposta.vue?vue&type=template&id=6e83b886&"
import script from "./Proposta.js?vue&type=script&lang=js&"
export * from "./Proposta.js?vue&type=script&lang=js&"
import style0 from "./Proposta.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QSkeleton,QIcon,QExpansionItem,QItemSection,QCard,QCardSection,QForm,QRadio,QSelect,QInput,QField,QBtn,QItem,QTooltip,QCircularProgress,QToggle,QLinearProgress,QTab});
